import { render, staticRenderFns } from "./challenge-detail.vue?vue&type=template&id=194c646e&"
import script from "./challenge-detail.vue?vue&type=script&lang=js&"
export * from "./challenge-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports